const SDK = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  Token: process.env.REACT_APP_TOKEN,
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL,
  FRONTEND_DOMAIN: process.env.REACT_APP_FRONTEND_DOMAIN,
};

export default SDK;
